import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

export const ShowMore = ({ showMoreText, showMoreObj }) => {
  const [toggleAssociations, setToggleAssociations] = useState(false);
  const linksShown = 2;

  const formatAssociations = (linkArray) => {
    return linkArray.map(link => {
      if (link.isDefault) {
        return `<span><b>${link.label}</b></span>`;
      } else {
        return `<a class="tracking-link" href="${link.link}" target="_blank" rel="noopener noreferrer">${link.label}</a>`;
      }
    }).join('|');
  };

  const parseAssociations = (data, maxDisplay) => {
    const displayedAssociations = data.slice(0, maxDisplay);
    const formatted = formatAssociations(displayedAssociations);
    if (data.length > maxDisplay) {
      return `${formatted}|An additional ${data.length - maxDisplay} not shown`;
    } else {
      return formatted;
    }
  };

  const formattedAssociations = parseAssociations(showMoreObj, toggleAssociations ? showMoreObj.length : linksShown);

  const showAssociations = () => {
    setToggleAssociations(!toggleAssociations);
  };

  return (
    <>
      <div className='linkContainer'>
        <div className='d-flex'>
          {formattedAssociations ? (
            <div className='card-bold'>{showMoreText}</div>
          ) : (
            ''
          )}
          <div>
            {showMoreObj.length > linksShown && (
              <Button className='e-link' onClick={showAssociations}>
                {toggleAssociations ? 'Show less' : `+ ${showMoreObj.length - linksShown} more`}
              </Button>
            )}
          </div>
        </div>
        <ul className='list-style-none'>
          {formattedAssociations ? (
            formattedAssociations.split('|').map((link, index) => (
              <li key={index} dangerouslySetInnerHTML={{ __html: link }}></li>
            ))
          ) : (
            ''
          )}
        </ul>
      </div>
    </>
  );
};